// The ONE action row of the full-screen add / edit forms (KAN-1075): CustomerFormActions,
// EmployeeFormActions and PlatformFormActions keep their own save orchestration (preflight,
// timeout, beat hook) and render THIS for the row, so the three can never drift.
//
// ONE rule on every device (founder, KAN-1075): NO Cancel button — the header ✕ cancels, through the
// same unsaved-changes guard — and ONE FULL-WIDTH primary (phone / tablet bottom bar and the desktop
// rail's submit block). These forms have nothing for a left slot (no total, no hint), so the primary
// fills the row at rest and the beat plays in that same box.
//
// The working / saved beat plays inside the primary's box (the kit's one-box Fill). The save,
// working AND success labels are all latched at the tap (useLatchedWhile): the parent re-derives
// create / edit wording while the form closes (KAN-768). The primary reserves width for the
// longest idle label (`saveLabels`).
import useLatchedWhile from '../../../hooks/ui/useLatchedWhile';
import FullScreenActionRow from './FullScreenActionRow';

export default function FormActionRow({
  layout, working = false, phase = 'working', reduced = false,
  saveLabel, saveLabels = [], workingLabel, successLabel,
  onSave, saveDisabled = false,
  saveTestId, rowTestId,
}) {
  const shownSaveLabel = useLatchedWhile(saveLabel, working);
  const shownWorkingLabel = useLatchedWhile(workingLabel, working);
  const shownSuccessLabel = useLatchedWhile(successLabel, working);
  return (
    <FullScreenActionRow
      layout={layout}
      secondary={null}
      fillPrimary
      primary={{
        label: shownSaveLabel,
        labels: [...saveLabels, shownSaveLabel],
        onClick: onSave,
        testId: saveTestId,
        disabled: saveDisabled,
      }}
      beat={working ? { phase: phase === 'success' ? 'success' : 'working', workingLabel: shownWorkingLabel, successLabel: shownSuccessLabel, reduced } : null}
      testId={rowTestId}
    />
  );
}
